import { normaliseEmailArray, normaliseStrArray } from "src/utils/arrayNormalisation";
import { ObjectCompare } from "src/utils";
import {
  CreateUserAccountFormData,
  UpdateUserAccountFormData,
  PatchUserAccountRequestBody,
  UserAccount,
  UserRole
} from "src/types";

export class UpdateUserAccountMapper {
  public static initUpdateUserAccountFormData(userRoleDefaultValue: UserRole = "NONE"): UpdateUserAccountFormData {
    return {
      email: "",
      name: "",
      jobTitle: "",
      supervisorEmails: [""],
      vendorNames: [""],
      role: userRoleDefaultValue
    };
  }

  public static initUserAccountFormDataFromUserAccount(
    userAccount: UserAccount,
    vendorNames: string[] = []
  ): UpdateUserAccountFormData {
    return {
      email: userAccount.email ?? "",
      name: userAccount.name ?? "",
      role: userAccount.role ?? "NONE",
      jobTitle: userAccount.jobTitle ?? "",
      supervisorEmails: userAccount.supervisorEmails ?? [""],
      vendorNames: vendorNames
    };
  }

  public static updateUserAccountRequestBodyFromFormData(
    formData: CreateUserAccountFormData,
    initialFormData?: CreateUserAccountFormData
  ): PatchUserAccountRequestBody {
    const normalisedRole = formData.role === initialFormData?.role ? undefined : formData.role;
    const normalisedName = formData.name === initialFormData?.name || "" ? undefined : formData.name;
    const normalisedJobTitle =
      formData.jobTitle === initialFormData?.jobTitle || "" ? undefined : formData.jobTitle || null;
    const normalisedSupervisorEmails = ObjectCompare.isEqual(
      formData.supervisorEmails,
      initialFormData?.supervisorEmails
    )
      ? undefined
      : normaliseEmailArray(formData.supervisorEmails) || [];
    const normalisedVendorNames = ObjectCompare.isEqual(formData.vendorNames, initialFormData?.vendorNames)
      ? undefined
      : normaliseStrArray(formData.vendorNames) || [];

    return {
      role: normalisedRole,
      name: normalisedName,
      jobTitle: normalisedJobTitle,
      supervisorEmails: normalisedSupervisorEmails,
      vendorNames: normalisedVendorNames
    };
  }
}
